import {IAuthenticationState} from "../../state/security/authentication.state";
import {IAppState} from "../../state/app.state";
import {createSelector} from "@ngrx/store";

export const selectAuthentication = createSelector(
  (state: IAppState) => state.authentication,
  (state: IAuthenticationState) => state.data
);
